<hr />
<div class="text-muted p-15 m-t-10 footer text-center">
  <small>© 2007 - 2023 IT Database</small><br /><small
    >Privacy Policy and Terms of Service</small
  >
</div>
